{
  "dss": {
    "button": {
      "back": "Volver",
      "cancel": "Cancelar",
      "close": "Cerca",
      "confirmDelete": "Sí, eliminar",
      "continue": "Continuar",
      "logout": "Cerrar sesión",
      "passwordReset": "Restablecer contraseña",
      "save": "Ok",
      "verify": "Verificar"
    },
    "error": {
      "403": "No tiene acceso a esta página.",
      "404": "Esta página no existe.",
      "generic": "Se ha producido un error. Por favor, inténtelo de nuevo más tarde.",
      "throttling": "Demasiados intentos. Esta operación está bloqueada por un tiempo.",
      "title": "Error",
      "title403": "Acceso denegado",
      "title404": "No se encuentra"
    },
    "footer": {
      "imprint": "Aviso legal",
      "legalEntity": "Andreas STIHL, S.A. Torres de la Alameda, Madrid.",
      "privacy": " Protección de datos",
      "terms": "Términos y condiciones"
    },
    "label": {
      "CRMAccountNumber": "Nº de cuenta CRM",
      "contact": "Contactos",
      "email": "Email",
      "faq": "FAQ",
      "female": "Ms.",
      "firstname": "Nombre",
      "help": "Ayuda",
      "language": "Idioma",
      "lastname": "Apellido",
      "male": "Mr.",
      "needHelp": "¿Necesitas ayuda?",
      "newPassword": "Nueva contraseña",
      "newPassword2": "Confirmar nueva contraseña",
      "oldPassword": "Contraseña actual",
      "organization": "Distribuidor",
      "password": "Contraseña",
      "required": "requerido",
      "salutation": "Saludo",
      "select": "Por favor, seleccione"
    },
    "link": {
      "contact": "https://support.stihl.com/es-ES/websso-contact/",
      "faq": "https://support.stihl.com/es-ES/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Confirmar Registro",
        "wait": "Por favor, espere para completar la confirmación de la cuenta."
      },
      "otp": {
        "btnResend": "Reenviar correo electrónico con código de verificación",
        "msg": {
          "invalidOTP": "La contraseña de un solo uso introducida no es válida.",
          "resendFail": "No se ha podido reenviar el código. Vuelva a intentarlo más tarde."
        },
        "spamDetail": "Compruebe su bandeja de entrada y su carpeta de correo no deseado para ver si hay un correo electrónico de STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "¿No has recibido un correo electrónico?",
        "subtitle": "Para continuar, debe verificar su dirección de correo electrónico.",
        "title": "Verifique su cuenta de usuario",
        "txtVerifyMail": "Introduzca el nuevo código de verificación que le hemos enviado a su dirección de correo electrónico {email}"
      },
      "personal": {
        "msg": {
          "noChange": "No hay nada que actualizar.",
          "updateError": "No se han actualizado los datos personales.",
          "updated": "Los datos personales fueron actualizados.",
          "userLoadErr": "Error al cargar los datos del usuario. Vuelva a intentarlo más tarde."
        },
        "secOrganization": "Empresa",
        "secPersonal": "Personal",
        "secSettings": "Configuración preferida",
        "title": "Información personal"
      },
      "postPwSet": {
        "info": "Ahora puede utilizar su nueva contraseña.",
        "link_name": "Continuar con el autoservicio",
        "link_url": "/user/ui/",
        "title": "Su contraseña ha sido cambiada"
      },
      "resetPW": {
        "title": "Restablecer la contraseña"
      },
      "security": {
        "2fa": {
          "availableMethods": "Métodos de 2FA disponibles:",
          "info": "La autenticación de dos factores (2FA) es una función de seguridad que agrega una capa adicional de protección a tu cuenta. Requiere que utilices dos métodos para iniciar sesión, en lugar de solo un usuario y contraseña.",
          "method": {
            "email": "Correo electrónico",
            "emailDesc": "Recibe códigos únicos enviados a tu correo electrónico para completar las solicitudes de autenticación.",
            "oath": {
              "add": {
                "button": "Registrar la aplicación de autenticación"
              }
            }
          }
        },
        "authenticator": "Aplicación de autenticación",
        "infoFederatedAccount": "Esta cuenta está gestionada por el proveedor de identidad de su organización, por lo que la contraseña no se puede cambiar aquí. Para cambiar su contraseña, inicie sesión a través de la página de inicio de sesión de su organización o póngase en contacto con su administrador de TI.",
        "lastUse": "Último uso a las {0}.",
        "msg": {
          "invalidPassword": "La contraseña actual proporcionada no es válida.",
          "passwordAlreadyUsed": "No se pueden reutilizar las últimas 5 contraseñas.",
          "pwUpdateError": "Se ha producido un error al intentar cambiar la contraseña.",
          "pwUpdated": "La contraseña fue cambiada."
        },
        "noDevice": "No configurado",
        "oathAdd": {
          "appInfo": "Las aplicaciones de autenticación como {0}, {1}, etc. generan contraseñas de un solo uso que se utilizan como segundo factor durante el inicio de sesión.",
          "badCode": "Código no válido, inténtelo de nuevo.",
          "error": "Se produjo un error al intentar registrar el dispositivo autenticador.",
          "headScan": "1. Escanea el código QR con tu aplicación de autenticación",
          "headVerify": "2. Verificar el código",
          "infoKey": "clave de configuración",
          "infoKeyTitle": "Tu secreto de dos factores",
          "infoScanBottom": "¿No se puede escanear? Puedes usar {0} para configurar manualmente tu aplicación de autenticación.",
          "infoVerify": "Ingrese el código generado por su aplicación de autenticación.",
          "success": "Tu dispositivo de autenticación ha sido registrado. Ahora puedes usarlo para iniciar sesión.",
          "title": "Registra tu dispositivo de autenticación de dos factores"
        },
        "oathDelete": {
          "error": "Se produjo un error al intentar eliminar el dispositivo autenticador.",
          "success": "El dispositivo autenticador fue eliminado."
        },
        "passkeys": {
          "about": {
            "info1": "Las llaves de acceso son pares de claves criptográficas (una clave pública y una privada) que se almacenan en un autenticador que controlas. El autenticador puede demostrar que un usuario está presente y está autorizado para usar la llave de acceso. Los autenticadores prueban la autorización con un PIN, código, datos biométricos o contraseña de dispositivo, dependiendo de las capacidades y configuración del autenticador. Los autenticadores vienen en muchas formas, como un iPhone o dispositivo Android, Windows Hello, una llave de seguridad de hardware FIDO2 o un administrador de contraseñas.",
            "info2": "Cuando inicias sesión en STIHL usando una llave de acceso, tu autenticador utiliza criptografía de clave pública para demostrar tu identidad a STIHL sin enviar nunca la llave de acceso. Las llaves de acceso están vinculadas a un dominio de sitio web, como stihl-sso.com, y requieren una conexión segura, lo que significa que el navegador web rechazará la autenticación en un sitio web de phishing similar. Estas propiedades hacen que las llaves de acceso sean altamente resistentes al phishing y mucho más difíciles de atacar que los SMS o TOTP 2FA, que pueden ser vulnerables a ataques de phishing.",
            "info3": "Los servicios de llaves de acceso respaldados en la nube permiten que las llaves de acceso se sincronicen entre dispositivos (como dispositivos Apple, Android o administradores de contraseñas) para que se puedan usar desde más lugares y sean menos propensas a perderse. Una vez que hayas configurado una llave de acceso sincronizada en un dispositivo, esa llave estará disponible para usarse en varios dispositivos que utilicen el mismo servicio. Por ejemplo, si registras una llave de acceso con tu cuenta de iCloud utilizando el Touch ID de tu MacBook, luego puedes usar esa llave de acceso con tu rostro, huella dactilar, PIN o contraseña de dispositivo de manera intercambiable en múltiples dispositivos vinculados a la misma cuenta de iCloud.",
            "title": "Acerca de las llaves de acceso"
          },
          "add": {
            "button": "Añadir nueva llave de acceso",
            "error": "Ocurrió un error al intentar añadir la nueva llave de acceso.",
            "success": "Se ha añadido una nueva llave de acceso."
          },
          "delete": {
            "button": "Eliminar llave de acceso",
            "error": "Ocurrió un error al intentar eliminar esta llave de acceso.",
            "success": "La llave de acceso ha sido eliminada."
          },
          "edit": {
            "error": "Ocurrió un error al intentar guardar el nombre de la llave de acceso.",
            "name": "Nombre de la llave de acceso",
            "success": "El nombre de la llave de acceso ha sido actualizado.",
            "title": "Asigna un nombre a tu llave de acceso para distinguirla de otras llaves de acceso"
          },
          "info": "La llave de acceso es una alternativa simple y segura a las contraseñas, que valida tu identidad mediante toque, reconocimiento facial, una contraseña de dispositivo o un PIN.",
          "none": "No hay ninguna llave de acceso configurada.",
          "reallyDelete": "¿Estás seguro de que deseas eliminar la llave de acceso?",
          "registeredPasskeys": "Tus llaves de acceso registradas:",
          "title": "Llaves de acceso"
        },
        "reallyDeleteDevice": "¿Está seguro de que desea eliminar el dispositivo autenticador?",
        "secMFA": "Multi-Factor Authentication",
        "secPwdChange": "Cambiar contraseña",
        "title": "Login Seguridad"
      },
      "setPW": {
        "acceptTC": "Confirme nuestros {terms} y lea nuestro {privacy}.",
        "killSSO": "Anular todas las sesiones activas",
        "msg": {
          "tokenExpired": "El enlace o código de la contraseña ha caducado. Por favor, siga el enlace para restablecer su contraseña: {link}."
        },
        "privacy": "Protección de datos",
        "terms": "Términos y condiciones",
        "title": "Introduzca la nueva contraseña"
      }
    },
    "validations": {
      "hasDigit": "Debe contener dígitos",
      "hasLowercase": "Debe contener caracteres en minúscula",
      "hasSpecial": "Debe contener carácter(es) especial(es): {chars}",
      "hasUppercase": "Debe contener caracteres en mayúsculas",
      "invalidCharacters": "Contiene caracteres no válidos",
      "maxLength": "Máximo {max} de caracteres permitidos",
      "minLength": "Mínimo {min} caracteres requeridos",
      "notSameAsEmail": "Demasiado similar a la dirección de correo electrónico",
      "onlyValidCharactersAllowed": "Sólo se permiten letras, números y espacios.",
      "required": "Valor requerido",
      "sameAsPassword": "Las contraseñas no coinciden",
      "tcAccepted": "Confirme nuestras condiciones de uso STIHL.",
      "validEmail": "Dirección de correo electrónico no válida.",
      "validOTP": "Por favor, introduzca el código de verificación."
    }
  }
}
